import React, { useCallback } from 'react';
import { Button, Modal } from 'gatorcomponents';
import * as Styles from './TemporaryDomainModal.styles';
import { useHistory } from 'react-router';
import useLocale from '@/hooks/useLocale';
import { useResize } from '@/hooks/useResize';

const TemporaryDomainModal = ({
  setSelectedTemporaryDomain,
  domain,
  hostingId,
}) => {
  const history = useHistory();
  const { routes: routesLocale, changeDomain: changeDomainLocale } = useLocale();

  const { blockTemporaryDomainEmailModal: locale } = changeDomainLocale;

  const windowRect = useResize();
  const { width } = windowRect;
  const isMobile = width < 600;

  const handleClose = useCallback(() => {
    setSelectedTemporaryDomain({
      domain: '',
      hostingId: '',
    });
  }, [setSelectedTemporaryDomain]);


  const redirectToChangeDomainHandler = useCallback(({ domain, hostingId }) => {
    history.push(`${routesLocale.emailsList}${routesLocale.changeDomain}/${hostingId}/${domain}`);
  }, [
    history,
    routesLocale.changeDomain,
    routesLocale.emailsList,
  ]);

  return (
    <Modal
      open
      onClose={handleClose}
      title={locale.title}
    >
      <Styles.TempMailContentWrapper>
        <Styles.TempMailContent>
          {locale.description(domain)}
        </Styles.TempMailContent>

        <Styles.ActionsWrapper>
          <Button
            testId="temp-domain-modal__back-button"
            variant="secondary"
            size="medium2"
            label={locale.backButton}
            width={isMobile ? 'full' : 'fit-content'}
            onClick={handleClose}
          />

          <Button
            testId="temp-domain-modal__continue-button"
            size="medium2"
            label={locale.continueButton}
            width={isMobile ? 'full' : 'fit-content'}
            onClick={() => redirectToChangeDomainHandler({
              domain,
              hostingId,
            })}
          />
        </Styles.ActionsWrapper>
      </Styles.TempMailContentWrapper>
    </Modal>
  );
};

export default TemporaryDomainModal;
